/**
 * Parse an Excelsior id typed into an admin form.
 *
 * Blank means "not linked" (`null`); anything else must be a positive whole
 * number. Returns `undefined` when the input is invalid so callers can refuse
 * to submit it.
 */
export const parseExcelsiorId = (raw: string): number | null | undefined => {
    const trimmed = raw.trim();
    if (trimmed === "") return null;
    if (!/^\d+$/.test(trimmed)) return undefined;
    const value = Number(trimmed);
    return Number.isSafeInteger(value) && value > 0 ? value : undefined;
};

/** Render an Excelsior id for an input field (`null` becomes blank). */
export const formatExcelsiorId = (value: number | null | undefined): string =>
    value != null ? String(value) : "";
